import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconUnifiedCommunicationsProps } from './IconUnifiedCommunications.types'
import * as Styled from './styles/IconUnifiedCommunications.style'

import { nonThemeableRules } from '../../ruleSet'

const IconUnifiedCommunications: FC<IconUnifiedCommunicationsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconUnifiedCommunicationsProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconUnifiedCommunicationsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='m20.43 5.941-.157-.046a4.188 4.188 0 0 0-2.59.16c-.374.148-.722.36-1.03.625a2.668 2.668 0 0 0-.669.875c-.32.644-.28 1.41.098 2.023.195.309.45.574.75.781.332.223.7.391 1.09.493a4.21 4.21 0 0 0 1.305.125h.043a4.2 4.2 0 0 0 .464.265 3.371 3.371 0 0 0 1.36.348c.293.012.586-.016.87-.074 0 0-.913-.528-.937-1.07.215-.13.414-.278.598-.446.172-.164.324-.344.453-.543.121-.191.211-.398.274-.617a2.054 2.054 0 0 0-.239-1.66 2.404 2.404 0 0 0-.457-.555 4.193 4.193 0 0 0-1.226-.68'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='m20.047 5.844.05-.328c.098-.657-.331-1.278-.331-1.278a3.379 3.379 0 0 0-.97-1 4.482 4.482 0 0 0-1.398-.633 5.4 5.4 0 0 0-3.332.208c-.484.187-.93.46-1.324.796-.36.309-.656.688-.867 1.114-.2.414-.293.867-.27 1.324.012.285.075.57.18.836.11.27.254.52.438.742.187.234.41.445.652.625.25.184.762.41 1.063.54-.391.913-1.297 1.452-1.297 1.452A4.348 4.348 0 0 0 14.52 10c.41-.172.808-.371 1.187-.594l.227-.125'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M21.492 17.215a.3.3 0 0 1 .016.105 3.412 3.412 0 0 1-.153.97c-.375 1.214-1.386 2.523-2.582 2.874-3.015.898-6.191-.023-9-1.434a12.129 12.129 0 0 1-5.386-5.347c-1.414-2.797-2.34-5.957-1.438-8.957.356-1.188 1.676-2.196 2.895-2.567l.98-.257a.318.318 0 0 1 .383.203L7.98 5.07l1.184 3.305.027.086a.374.374 0 0 1-.125.426 4.328 4.328 0 0 1-1.27.664 7.861 7.861 0 0 1-1.671.324.37.37 0 0 0-.27.164.372.372 0 0 0-.043.309 12.339 12.339 0 0 0 3.012 4.976 12.32 12.32 0 0 0 5 3.004c.106.035.219.02.309-.043a.366.366 0 0 0 .164-.265 7.632 7.632 0 0 1 .328-1.672 4.26 4.26 0 0 1 .672-1.262.367.367 0 0 1 .426-.125l.086.027 3.316 1.18c.79.277 1.46.559 2.25.84.047.015.094.133.117.207Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconUnifiedCommunications
